export default "__VITE_ASSET___E5YmmYM__"